export default __webpack_public_path__ + "static/media/add_btn.1b9a99ae.svg";